export enum LocalStorageItems {
    SPORT_TRIALS = 'sportTrials',
    TOKEN = 'token',
}
